import { render, staticRenderFns } from "./ServerSelector.vue?vue&type=template&id=c9948630&"
import script from "./ServerSelector.vue?vue&type=script&lang=js&"
export * from "./ServerSelector.vue?vue&type=script&lang=js&"
import style0 from "./ServerSelector.vue?vue&type=style&index=0&id=c9948630&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports